import { FilterZone } from '@/types/filter'

export const compareFilterZones = (referenceZone: FilterZone, compareZone: FilterZone) =>
  referenceZone.slug.localeCompare(compareZone.slug, undefined, { numeric: true })
